/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import React, { useState, Fragment } from "react";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function GradientCircularProgress({ value }) {
  return (
    <Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#0097a7" />
            <stop offset="100%" stopColor="#3f51b5" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} variant="determinate" value={value}  />
    </Fragment>
  );
}

// COMPONENTE CIRCULAR CON PORCENTAJE
function CircularProgressWithLabel({ value }) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <GradientCircularProgress value={value} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" color="secondary">
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

// COMPONENTE PRINCIPAL CON PETICIÓN AXIOS
export default function DescargandoArchivo({progress}) {
 return <CircularProgressWithLabel value={progress} />
}
